import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Layout from '../components/common/Layout';
import Home from '../pages/Home';
import About from '../pages/About';
import Services from '../pages/Services';
import Blog from '../pages/Blog';
import Contact from '../pages/Contact';
import WebDevPackage from '../pages/WebDevPackage';
import MaintenancePackage from '../pages/MaintenancePackage';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import WebDevelopment from '../pages/WebDevelopment';
import DigitalMarketing from '../pages/DigitalMarketing';
import GraphicsDesign from '../pages/GraphicsDesign';

const router = createBrowserRouter([{
  path:'/',
  element:<Layout/>,
  children:[
    {index:true,                        element:<Home/>},
    {path:'/about',                      element:<About/>},
    {path:'/services',                   element:<Services/>},
    {path:'/services/web-development',   element:<WebDevelopment/>},
    {path:'/services/digital-marketing', element:<DigitalMarketing/>},
    {path:'/services/graphics-design',   element:<GraphicsDesign/>},
    {path:'/blog',                       element:<Blog/>},
    {path:'/contact',                    element:<Contact/>},
    {path:'/web-development-package',    element:<WebDevPackage/>},
    {path:'/maintenance-package',        element:<MaintenancePackage/>},
    {path:'/privacy-policy',             element:<PrivacyPolicy/>},
  ]
}]);

export default function AppRouter(){ return <RouterProvider router={router}/>; }
